<div class="floating-chat-container" *ngIf="isChatOpen">
  <div class="chat-header bg-color-accent p-2 flex">
    <span class="color-white text-bold header-name"></span>
    <slm-button-icon
      class="close-btn fill-white"
      [icon]="icons.CLOSE"
      (click)="closeChat()"
    ></slm-button-icon>
  </div>
  <div #chatMessageContainer class="chat-messages">
    @for (message of messages; track message){
      @switch (message.type) {
        @case ('bot') {
          <div>
            <div class="message">
              <div class="m-2">
                <slm-svg-icon
                  class="mr-3"
                  [icon]="icons.SMART_TOY"
                ></slm-svg-icon>
                <span class="msg" [innerHtml]="message.message"></span>
                <span class="time">{{ message.time }}</span>
              </div>
            </div>
          </div>
        }
        @case ('user'){
          <div class="flex flex-end">
            <div class="message message-user">
              <div class="m-2">
                <slm-monogram
                  [user]="user$ | async"
                  fontSize="1em"
                  color="rgba(73, 75, 116, 0.25)"
                  class="mr-3"
                  size="1.5"
                ></slm-monogram>
                <span class="msg" [innerHtml]="message.message"></span>
                <span class="time">{{ message.time }}</span>
              </div>
            </div>
          </div>
        }
      }
    }
    <div *ngIf="isLoading()"
         class="message flex"
    >
      <div class="m-2">
        <slm-svg-icon
          class="mr-3"
          [icon]="icons.SMART_TOY"
        ></slm-svg-icon>
        <span class="msg mr-2 mt-1">{{ 'ANSWER_IN_PROGRESS' | translate }}</span>
        <div class="message-loader float-right"></div>
      </div>
    </div>

  </div>
  <div class="chat-input flex">
    <div class="flex-grow-auto mr-3 mb--4">
      <slm-text-input
        [control]="chatMessageControl"
        [errors]="errors"
        [hideOptionalLabel]="true"
        (keydown.enter)="sendMessage()"
        placeholder="{{'WRITE_SOMETHING' | translate}}"
      >
      </slm-text-input>
    </div>
    <slm-button-icon
      class="size-25 ml-auto mt-1_5 fill-white bg-color-accent"
      [icon]="icons.SEND"
      (click)="sendMessage()"
    ></slm-button-icon>
  </div>
</div>

<slm-button-icon
  *ngIf="showChatButton()"
  class="open-chat-btn size-2 mr-4 fill-white bg-color-accent"
  [rounded]="true"
  [icon]="icons.CHAT"
  [size]="'1.5em'"
  matBadge="!"
  matBadgePosition="before"
  matBadgeSize="small"
  matBadgeColor="warn"
  [matBadgeHidden]="!showChatButtonBadge()"
  (click)="openChat()"
></slm-button-icon>
